import React from "react";
import './hinnasto.css'

function Hinnasto() {
  return (
 <div className="div">

    <div className="content-grid hinnasto">
    <h1>Palveluhinnasto</h1>
        <div className="box text-box">
            <h2>Testamentti</h2>
            <p>
                Todistaminen hoidetaan toimistollani (2 tapaamista)
                
            </p>
            <p>325€ (sis.alv)</p>
        </div>
        <div className="box text-box">
            <h2>Testamentti</h2>
            <p>
                Todistaminen hoidetaan asiakkaan toimesta (1 tapaaminen). 
            </p>
            <p>275 € (sis. alv)</p>
        </div>
        <div className="box text-box">
            <h2>Edunvalvontavaltakirja</h2>
            <p>
                Todistaminen hoidetaan toimistolla (2 tapaamista).
            </p>
            <p> 275 € (sis. alv)</p>
        </div>
        <div className="box text-box">
            <h2>Edunvalvontavaltakirja</h2>
            <p>
                Todistaminen hoidetaan asiakkaan toimesta (1 tapaaminen).
                
                
            </p>
            <p>225 € (sis. alv)</p>
        </div>
        <div className="box text-box">
            <h2>Testamentti & edunvalvontavaltakirja</h2>
            <p>
                Samalla toimeksiannolla, todistaminen toimistollani (2 tapaamista).
                
                
            </p>
            <p>500 € (sis. alv)</p>
        </div>
        <div className="box text-box">
            <h2>Testamentti & edunvalvontavaltakirja</h2>
            <p>
                Samalla toimeksiannolla, asiakas hoitaa todistamisen (1 tapaaminen).
            

            </p>
            <p>450 € (sis. alv)</p>
        </div>
            <div className="box text-box">
            <h2>Muut toimeksiannot</h2>
            <p>
                Esimerkiksi perunkirjoitukset, perinnönjaot, ositukset
                
            </p>
            <p>251 € / h (sis. alv)</p>
        </div>
    </div>
</div>    
  );
}

export default Hinnasto;
